import * as a0 from "@take-2/assets/versions" with { type: "json" }
let a0_ = "" + void a0;
import '@take-2/views/layouts/partials/baseGlobalStyles.client.css';
import '@take-2/views/layouts/base.client.ts';
import '@take-2/views/layouts/partials/desktopGlobalStyles.client.css';
import '@take-2/views/layouts/desktop.client.ts';
import '@take-2/views/person/overview/biographyDesktop.client.css';
import * as a1 from "swug:include:person/overview/partials/header.html"
let a1_ = "" + void a1;
import * as a2 from "swug:include:person/overview/partials/headshot.html"
let a2_ = "" + void a2;
import * as a3 from "swug:include:shared/partials/ad.html"
let a3_ = "" + void a3;
import * as a4 from "swug:include:news/partials/bricks.html"
let a4_ = "" + void a4;
import * as a5 from "swug:include:layouts/partials/desktopGlobalStyles.html"
let a5_ = "" + void a5;
import * as a6 from "swug:include:shell/topBanner.html"
let a6_ = "" + void a6;
import * as a7 from "swug:include:fd-pkgs/fd-header/desktop/header.html"
let a7_ = "" + void a7;
import * as a8 from "swug:include:shell/offerBanner.html"
let a8_ = "" + void a8;
import * as a9 from "swug:include:fd-pkgs/fd-footer/desktop/footer.html"
let a9_ = "" + void a9;
import * as a10 from "swug:include:shell/jsonLD.html"
let a10_ = "" + void a10;
import * as a11 from "swug:include:layouts/partials/baseGlobalStyles.html"
let a11_ = "" + void a11;
import * as a12 from "swug:include:shell/mpsPageIntegration.html"
let a12_ = "" + void a12;
import * as a13 from "swug:include:shell/covidModalContent.html"
let a13_ = "" + void a13;
import * as a14 from "swug:include:shared/partials/_offeringModal.html"
let a14_ = "" + void a14;
import * as a15 from "swug:include:shell/globalOfferModal.html"
let a15_ = "" + void a15;
import * as a16 from "swug:include:layouts/partials/oneTrustScripts.html"
let a16_ = "" + void a16;